export class OAuthError extends Error {}

export class OAuthWindowClosedError extends OAuthError {}

export class AuthError extends Error {}

export class NoRoleError extends AuthError {}

export class NoPhoneNumbersError extends AuthError {}

export class UnassignedPhonesError extends AuthError {}

export class BlockedUserError extends AuthError {}

export class NoBusinessError extends AuthError {}

export class VonageError extends Error {}

export class NoVonageTokenError extends VonageError {}

export class NoVonageSessionError extends VonageError {
  constructor(cause?: unknown) {
    const causeMessage = cause instanceof Error ? cause.message : cause ? String(cause) : 'unknown';
    super(`Failed to create Vonage session: ${causeMessage}`, { cause });
    this.name = 'NoVonageSessionError';
  }
}
